module.exports = __webpack_public_path__ + "img/bg-banner-accent.07663d8b.png";